import Tournaments from '../components/pages/Tournaments/Tournaments.vue'
import TournamentsTable from '../components/pages/Tournaments/TournamentsTable/TournamentsTable.vue'

const TournamentsTableHead = () => import('../components/pages/Tournaments/TournamentsTableHead')
const TournamentsFilters = () => import('../components/pages/Tournaments/TournamentsFilters')

export default [
  {
    path: '/tournaments',
    component: Tournaments,
    children: [
      {
        name: 'tournaments',
        path: '',
        components: {
          default: TournamentsTable,
          tableHead: TournamentsTableHead,
          filters: TournamentsFilters
        }
      }
    ]
  }
]
